import { render, staticRenderFns } from "./AdminPanelDashboardMenuItem.vue?vue&type=template&id=1fc8b34a"
import script from "./AdminPanelDashboardMenuItem.vue?vue&type=script&lang=js"
export * from "./AdminPanelDashboardMenuItem.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDashboardMenuItem.vue?vue&type=style&index=0&id=1fc8b34a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports